import type { TranslationTree } from '../../types';

export const admin: TranslationTree = {
  admin: {
    hero: {
      badge: 'Administratorbereich',
      title: 'Verwalten Sie Zugänge mühelos',
      description:
        'Erstellen Sie Konten, weisen Sie Module zu und synchronisieren Sie Ihre Werkzeuge in wenigen Klicks. So behalten Sie die volle Kontrolle über Ihre ToolLife-Plattform.',
    },
    tabs: {
      users: 'Benutzer:innen',
      tools: 'Werkzeuge',
    },
    sections: {
      userCreation: {
        title: 'Neues Benutzerkonto erstellen',
        description:
          'Geben Sie die erforderlichen Informationen ein und wählen Sie die Module aus, auf die der Account zugreifen darf.',
      },
      toolCreation: {
        title: 'Neues Werkzeug registrieren',
        description:
          'Fügen Sie ein Werkzeug zur Traceability-Datenbank hinzu, damit es im ToolLife-Ökosystem verfügbar wird.',
      },
    },
    registerForm: {
      fields: {
        firstName: {
          label: 'Vorname',
          placeholder: 'z. B. Jeanne',
        },
        lastName: {
          label: 'Nachname',
          placeholder: 'z. B. Martin',
        },
        email: {
          label: 'E-Mail-Adresse',
          placeholder: 'vorname.nachname@unternehmen.ch',
        },
        company: {
          label: 'Unternehmen',
          placeholder: 'Name des Unternehmens',
        },
        password: {
          label: 'Passwort',
          placeholder: '••••••••',
        },
        confirmPassword: {
          label: 'Passwort bestätigen',
          placeholder: '••••••••',
        },
      },
      role: {
        title: 'Zugewiesene Rolle',
        description: 'Aktivieren Sie diese Option, um dem Konto Administratorrechte zu erteilen.',
        adminLabel: 'Administrator:in',
      },
      modules: {
        title: 'Verfügbare Module',
        options: {
          traceability: {
            label: 'Traceability',
            description: 'Echtzeit-Verfolgung der Produktionsmeldungen.',
          },
          machineLearning: {
            label: 'Machine Learning',
            description: 'Prädiktive Modelle zur frühzeitigen Anomalie-Erkennung.',
          },
          analytics: {
            label: 'Analytics',
            description: 'Erweiterte Statistiken und individuelle Dashboards.',
          },
        },
      },
      submit: 'Konto erstellen',
      success: 'Benutzer erfolgreich hinzugefügt!',
      errors: {
        passwordMismatch: 'Die Passwörter stimmen nicht überein',
        default: 'Es ist ein Fehler aufgetreten',
      },
    },
    registerToolForm: {
      fields: {
        toolId: {
          label: 'Werkzeugkennung',
          placeholder: 'z. B. TL-4587',
        },
        reference: {
          label: 'Interne Referenz',
          placeholder: 'Herstellerreferenz',
        },
        company: {
          label: 'Zugehöriges Unternehmen',
          placeholder: 'Name des Unternehmens',
        },
      },
      info: 'Hier registrierte Werkzeuge stehen sofort für Traceability und Analytics in ToolLife zur Verfügung.',
      submit: 'Werkzeug hinzufügen',
      success: 'Werkzeug erfolgreich hinzugefügt!',
      errors: {
        default: 'Es ist ein Fehler aufgetreten',
      },
    },
    permissionError: {
      title: 'Seite nicht verfügbar',
      backHome: 'Zur Startseite',
    },
  },
};
